import Parse from 'parse'
import {ParseDbService, songTypeSchema as Schema} from "./parse.db.service";

function getAll(pagination, search) {
    let query = new Parse.Query(ParseDbService.SongTypeClassName);
    if (pagination) {
        query.skip((pagination.page - 1) * pagination.perPage)
            .limit(pagination.perPage)
    }
    query.withCount(true);

    if (search !== undefined && search != null && search.length !== 0) {
        query.contains(Schema.name, search);
    }

    return query.find().then(items => {
        return {
            results: items.results.map(item => {
                return {
                    parseItem: item,
                    name: item.get(Schema.name)
                }
            }),
            count: items.count
        }
    });
}


function add(item) {
    let SongType = Parse.Object.extend(ParseDbService.SongTypeClassName, null, null);
    let songTypeObj = new SongType();
    songTypeObj.set(Schema.name, item.name.toLowerCase());
    return songTypeObj.save();
}

function edit(item) {
    let songTypeObj = item.parseItem;
    songTypeObj.set(Schema.name, item.name.toLowerCase());
    return songTypeObj.save();
}

export const SongTypeService = {
    getAll,
    add,
    edit
};

